module.exports = __webpack_public_path__ + "static/media/coughing.35c6649a.jpg";